import React, { useState, useEffect } from "react";
import DoneIcon from "@mui/icons-material/Done";
import PersonIcon from "@mui/icons-material/Person";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import { useNavigate } from "react-router";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Select,
  ClickAwayListener,
} from "@mui/material";
import ApiMethods from "../../../../ApiManager/ApiMethods";
import moment from "moment";
import FreeSoloCreateOption from "./AutoComplete";
import { useAlert } from "../../../context/AlertContext";
import { refreshClientPackages } from "../../../data/membersStore";

const CardClient = ({
  appointment,
  isPastDayAndHour,
  booking_client,
  updateStateReservation,
  start,
  end,
  setActiveReschedule,
  setActiveClientInformation,
  setClientActive,
  setActiveAppointment,
  setNavBar,
  view,
  setOpenSidebarClient,
  activeAppointment,
  setUpdateActiveReschedule,
  id,
}) => {
  const [openPopup, setOpenPopup] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [isCanceling, setIsCanceling] = useState(false);
  const [noteText, setNoteText] = useState("");
  const [reasonCanceling, setReasonCanceling] = useState("");
  const { showAlert, closeAlert } = useAlert();
  const [checkedNoShow, setCheckedNoShow] = useState(false);
  const [canceled, setCanceled] = useState(false);
  const [isNoShow, setIsNoShow] = useState(false);
  let navigate = useNavigate();
  const startMoment = moment(activeAppointment.start);
  const endMoment = moment(activeAppointment.end);
  const startDate = startMoment.format("YYYY/MM/DD");
  const startTime = startMoment.format("HH:mm");

  let newApp = activeAppointment.bookings_client.filter((client) => {
    return (
      client.status === "noshow" && client.client_id == booking_client.client_id
    );
  });

  useEffect(() => {
    const newApp = activeAppointment.bookings_client.filter((client) => {
      return (
        client.status === "noshow" &&
        client.client_id === booking_client.client_id
      );
    });

    if (newApp.length > 0) {
      setIsNoShow(true);
    } else {
      setIsNoShow(false);
    }
  }, [activeAppointment, booking_client]);
  const endDate = endMoment.format("YYYY/MM/DD");
  const endTime = endMoment.format("HH:mm");
  const handleChange = (event) => {
    setNoteText(event.target.value);
  };

  const handleChangeChecked = (e) => {
    setCheckedNoShow(e.target.checked);
    setCanceled(false);
  };
  const handleChangeCanceled = (e) => {
    setCanceled(e.target.checked);
    setCheckedNoShow(false);
  };

  const handleCancelBooking = async () => {
    try {
      const data = {
        client_id: id,
        timeSlot_id: appointment.id,
      };
      await ApiMethods.post("auth/delete_bookings", data);
      // A cancellation frees up a package session — refresh this client's cached package
      // rows so Members/the package popup reflect it without a full member reload.
      refreshClientPackages(id);
      updateStateReservation();
    } catch (err) {
      console.log(err, "err");
    }

    console.log("Cancel the booking");
    setOpenPopup(false);
    setNavBar(false);
  };

  const handleClosePopup = () => {
    setActiveAppointment({});
  };
  const handleRescheduleClick = () => {
    navigate(`/calendar`, {
      state: { id: booking_client.client_id },
    });
  };

  const handleCancelTrainingClick = () => {
    navigate("/cancel-training");
  };

  const handleChangeAppointment = () => {
    console.log(booking_client);
    setActiveClientInformation(booking_client);
    setClientActive(booking_client.client_id);
    setActiveReschedule();
    setActiveAppointment({});
  };

  const handleProfileClick = () => {
    setActiveClientInformation(booking_client);
    setClientActive(booking_client.client_id);
    setActiveAppointment({});
  };

  const addComment = async () => {
    try {
      if (!checkedNoShow && !canceled) {
        showAlert("Morate odabrati tip otkazivanja", "error");
        return;
      }

      if (reasonCanceling == "" && reasonCanceling.title == "") {
        showAlert("Morate odabrati razlog otkazivanja", "error");
      }

      let type = checkedNoShow ? "noshow" : "canceled";
      const comment = reasonCanceling.title
        ? reasonCanceling.title
        : reasonCanceling;
      console.log(comment);
      const data = {
        client_id: booking_client.client_id,
        timeSlot_id: booking_client.timeSlot_id,
        comment: comment,
        type: type,
      };

      // console.log("data", data);
      // return;

      const response = await ApiMethods.post("auth/delete_bookings", data);

      if (response?.message) {
        showAlert("Uspešno ste otkazali termin", "success");
      } else {
        showAlert("Nešto je pošlo po zlu", "error");
      }

      // A cancellation/no-show frees up (or, for no-show, still consumes but the count may
      // have changed) a package session — refresh this client's cached package rows so
      // Members/the package popup reflect it without a full member reload.
      refreshClientPackages(booking_client.client_id);

      setUpdateActiveReschedule();
      setActiveAppointment({});
    } catch (err) {
      console.log("err", err);
    }
  };
  const handleCancelClick = () => {
    setIsCanceling(!isCanceling); // Switch to the canceling state
  };
  return (
    <>
      <div className="popup-overlay">
        {" "}
        <ClickAwayListener onClickAway={handleClosePopup}>
          <div
            className={`popup-container-client ${
              isCanceling ? "canceling" : ""
            }`}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                height: "auto",
                flexDirection: "column",
              }}
            >
              <span className="header-name-date">
                {" "}
                Termin: {startDate}-{startTime}- {endTime}
              </span>
              <div>
                {isNoShow ? (
                  <span style={{ color: "#ff4d4f", fontSize: "16px" }}>
                    (Nije se pojavio)
                  </span>
                ) : null}
              </div>
              <span
                onClick={handleClosePopup}
                style={{
                  color: "black",
                  fontSize: "16px",
                  cursor: "pointer",
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                }}
              >
                ✖
              </span>
            </div>
            <div className="popup-header">
              <span className="circle-popup"></span>

              <div className="noShow-header" style={{ height: "auto" }}>
                <span className="header-name">
                  {booking_client.first_name} {booking_client.last_name}
                </span>
              </div>
            </div>
            {isCanceling && (
              <div className="buttons-part-noShow">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={checkedNoShow}
                        onChange={handleChangeChecked}
                      />
                    }
                    label="Nije se pojavio"
                    sx={{ height: "auto" }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={canceled}
                        onChange={handleChangeCanceled}
                      />
                    }
                    label="Otkazao"
                    sx={{ height: "auto" }}
                  />
                </div>
                <FreeSoloCreateOption setReasonCanceling={setReasonCanceling} />

                <div className="buttons-popup" style={{ marginTop: "15px" }}>
                  <button
                    onClick={handleCancelClick}
                    className="button-reschedule"
                  >
                    Izađi
                  </button>
                  <button onClick={addComment} className="button-reschedule">
                    Potvrdi
                  </button>
                </div>
              </div>
            )}
            {!isCanceling && (
              <div className="buttons-part-noShow" style={{ width: "100%" }}>
                {!isPastDayAndHour && (
                  <div className="buttons-popup">
                    <button
                      disabled={isNoShow}
                      onClick={handleChangeAppointment}
                      className={`button-reschedule ${
                        isNoShow ? "button-disabled" : ""
                      }`}
                    >
                      Promeni Termin
                    </button>
                    <button
                      disabled={isNoShow}
                      onClick={handleCancelClick}
                      className={`button-reschedule ${
                        isNoShow ? "button-disabled" : ""
                      }`}
                    >
                      Otkaži trening
                    </button>
                  </div>
                )}
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <button
                    onClick={handleProfileClick}
                    className="profile-button"
                  >
                    Profil
                  </button>
                </div>
              </div>
            )}
          </div>
        </ClickAwayListener>
      </div>
    </>
  );
};

export default CardClient;
